<template>
  <div ref="home" class="home">
    <div class="newsBox">
      <!-- 弹窗 -->
      <div class="popWindow" v-show="dialogVisible">
        <div class="diaInner">
          <div class="closeDiv">
            <i class="el-icon-close" @click="dialogVisible = false"></i>
          </div>
          <img class="diaLogo" src="../assets/images/success.png" alt />
          <h4>感谢您的提交！</h4>
          <p>我们会在2个工作日内与您联系，请保持手机通畅</p>
          <span>(扫描二维码可在线咨询客服)</span>
          <img class="diaCode" src="../assets/images/code.png" alt />
        </div>
        <div class="modal"></div>
      </div>
      <!-- 提交信息 -->
      <div class="submitBox">
        <div class="submitInner">
          <!-- 左侧广告信息 -->
          <div class="sbLeft">
            <h4>我们将提供高质量的服务</h4>
            <div class="sbLeftBox">
              <div>
                <img src="../assets/images/plan_1.png" alt />
                <span>
                  <h4>网络即服务</h4>
                  <p>集中控制全球优质网络资源，融合SDP/SDN、网络安全和卓越网络性能于一身，并可无缝扩展</p>
                </span>
              </div>
              <div>
                <img src="../assets/images/plan_2.png" alt />
                <span>
                  <h4>零信任安全</h4>
                  <p>无处不在的网络安全保护您可以从全球任意位置安全访问</p>
                </span>
              </div>
              <div>
                <img src="../assets/images/plan_3.png" alt />
                <span>
                  <h4>一致的用户体验</h4>
                  <p>结合用户终端设备实施智能、动态、分级管理，即使受到攻击时，也可作到用户无感知</p>
                </span>
              </div>
              <div>
                <img src="../assets/images/plan_4.png" alt />
                <span>
                  <h4>一站式服务</h4>
                  <p>在任何情况下，Global Overlay Network平台的运维管理工作都由迈格网络始终负责</p>
                </span>
              </div>
            </div>
          </div>
          <!-- 右侧提交信息 -->
          <div class="sbRight">
            <h4>您将获得免费使用</h4>
            <p>
              现在申请您将获得
              <span>14</span>天免费使用资格
            </p>
            <div>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="0"
                class="demo-ruleForm"
              >
                <el-form-item label prop="name">
                  <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
                </el-form-item>
                <el-form-item label prop="phone">
                  <el-input v-model="ruleForm.phone" placeholder="您的联系电话"></el-input>
                </el-form-item>
                <el-form-item label prop="company">
                  <el-input v-model="ruleForm.company" placeholder="您的企业名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="btnBox">
                    <a
                      href="javaScript:void(0);"
                      class="comButton collection-1 btn-15"
                      @click="submitForm('ruleForm')"
                    >
                      <span>立即提交</span>
                    </a>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
import { isMobile } from '@/utils/validate'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    const validatPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的联系电话'))
      }
      if (!isMobile(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      ruleForm: {
        name: '',
        company: '',
        phone: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入您的企业名称', trigger: 'blur' }
        ],
        phone: [
          { trigger: 'blur', validator: validatPhone }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submit () {
      let params = {
        name: this.ruleForm.name,
        company: this.ruleForm.company,
        phonenumber: this.ruleForm.phone
      }
      this.$axios.post('/blog/api/addapplyprobation', this.$qs.stringify(params))
        .then(res => {
          if (res.data.status === 200) {
            this.dialogVisible = true
          }
        }).catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
// 移动端样式
@media only screen and (max-width: 1024px) {
  /deep/ .el-form {
    .el-form-item {
      .el-input {
        input {
          height: 2.875rem;
          font-size: 0.875rem;
        }
      }
    }
    .el-form-item:last-child {
      margin: 0;
    }
  }
  .newsBox {
    position: relative;
    box-sizing: border-box;
    padding: 5rem 0;
  }
  .submitBox {
    width: 92%;
    box-shadow: 0px 2px 12px 0px rgb(204, 204, 204, 0.5);
    border-radius: 1rem;
    margin-left: 4%;
    box-sizing: border-box;
    h4 {
      font-size: 1rem;
      font-weight: 600;
      color: #08142a;
      line-height: 1.375rem;
    }
    p {
      font-size: 0.875rem;
      font-weight: 300;
      color: #4c5461;
      line-height: 1.25rem;
      margin: 0.5rem 0 1.625rem;
      span {
        font-size: 1rem;
        color: #428bf8;
        font-weight: bold;
      }
    }
  }
  .submitInner {
    padding: 2rem;
  }
  .sbLeft {
    display: none;
  }
  .btnBox {
    width: 100%;
    text-align: center;
  }
  .comButton {
    color: #fff;
    border-radius: 0.875rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 2.25rem;
    font-size: 0.8125rem;
    margin: 0;
    padding: 0;
    max-width: 8rem;
    margin: 0 auto;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .popWindow {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    .modal {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      left: 0;
      top: 0;
      z-index: 8;
    }
    .diaInner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 90%;
      margin: 0 auto;
      background: #fff;
      position: relative;
      z-index: 9;
      border-radius: .5rem;
      margin-top: 5rem;
      padding: 0 1rem;
      .closeDiv {
        width: 100%;
        text-align: right;
        padding: 1.25rem .875rem .75rem;
        font-size: 1.3125rem;
        cursor: pointer;
        box-sizing: border-box;
      }
      .diaLogo {
        width: 64px;
        height: 64px;
      }
      .diaCode {
        width: 9.25rem;
        height: 9.25rem;
      }
      h4 {
        font-size: 1.25rem;
        font-weight: 600;
        color: #353535;
        margin: 1.4375rem 0 .9375rem;
      }
      p {
        font-size: .875rem;
        font-weight: 300;
        color: #353535;
        margin-bottom: 1rem;
      }
      span {
        font-size: 1rem;
        font-weight: 300;
        color: #999999;
        margin-bottom: 1.4375rem;
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  /deep/ .el-form {
    .el-form-item {
      .el-input {
        input {
          height: 58px;
          font-size: 16px;
        }
      }
    }
  }
  .diaBox {
    padding: 69px 92px 56px;
  }

  .home {
    width: 100%;
    background: #fff;
    // 按钮样式
    // banner图部分

    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      height: 50px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    // 通用标题
    .newsBox {
      position: relative;
      margin-top: 64px;
      padding: 152px;
      box-sizing: border-box;
      .popWindow {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 9;
        .modal {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          left: 0;
          top: 0;
          z-index: 8;
        }
        .diaInner {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 572px;
          margin: 0 auto;
          background: #fff;
          position: relative;
          z-index: 9;
          border-radius: 8px;
          padding-bottom: 40px;
          margin-top: 160px;
          .closeDiv {
            width: 100%;
            text-align: right;
            padding: 20px 30px 12px;
            font-size: 21px;
            cursor: pointer;
          }
          .diaLogo {
            width: 64px;
            height: 64px;
          }
          .diaCode {
            widows: 148px;
            height: 148px;
          }
          h4 {
            font-size: 20px;
            font-weight: 600;
            color: #353535;
            margin: 23px 0 15px;
          }
          p {
            font-size: 17px;
            font-weight: 300;
            color: #353535;
            margin-bottom: 24px;
          }
          span {
            font-size: 16px;
            font-weight: 300;
            color: #999999;
            margin-bottom: 23px;
          }
        }
      }
    }
    .submitBox {
      max-width: 1180px;
      margin: 0 auto;
      .submitInner {
        display: flex;
        box-shadow: 3px 0px 9px 2px rgba(204, 204, 204, 0.5);
        border-radius: 12px;
        .sbLeft {
          width: 570px;
          padding: 64px 90px 84px 64px;
          box-sizing: border-box;
          background: url(https://a.perfma.net/fe/assets/4440563) no-repeat;
          h4 {
            margin-bottom: 48px;
            font-size: 22px;
            font-weight: 600;
            color: #08142a;
          }
          .sbLeftBox {
            div {
              display: flex;
              margin-bottom: 35px;
              img {
                width: 46px;
                height: 42px;
                margin-right: 20px;
              }
              span {
                h4 {
                  font-size: 18px;
                  margin-bottom: 10px;
                }
                p {
                  font-size: 14px;
                  font-weight: 300;
                  color: #4c5461;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                }
              }
            }
          }
        }
        .sbRight {
          width: 550px;
          padding: 64px 90px 84px 64px;
          box-sizing: border-box;
          h4 {
            margin-bottom: 12px;
            font-size: 22px;
            font-weight: 600;
            color: #08142a;
          }
          p {
            margin-bottom: 50px;
            font-size: 16px;
            font-weight: 300;
            color: #4c5461;
            span {
              font-size: 22px;
              color: #428bf8;
              font-weight: bold;
            }
          }
          img {
            width: 105px;
            height: 32px;
          }
          .comButton {
            margin-left: 106px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/getPlan.vue